import { HttpService } from '@/shared/services'
import {
  AuthInput,
  AuthResponse,
  RefreshTokenInput,
  UpdatePasswordTemporaryInput,
  ChangePasswordInput,
  ConfirmAndChangePasswordInput,
} from '../dtos/interfaces'

const http = new HttpService()

export const confirmAndChangePassword = async (
  dto: ConfirmAndChangePasswordInput
) => {
  const response = await http.post<ConfirmAndChangePasswordInput, string>(
    '/user/confirmForgetPassword',
    {
      code: dto.code,
      email: dto.email,
      newPassword: dto.newPassword,
    }
  )

  return response.data
}

export interface ForgotPasswordResponse {
  temporaryPasswordResent?: boolean
}

export const sendRecoveryCode = async (email: string) => {
  const response = await http.post<{ email: string }, ForgotPasswordResponse>(
    '/user/forgetPassword',
    {
      email,
    }
  )

  return response.data
}

export const login = async (
  email: string,
  password: string
): Promise<AuthResponse | null> => {
  try {
    const response = await http.post<AuthInput, AuthResponse>('/user/login', {
      email,
      password,
    })
    return response.data
  } catch (error) {
    return null
  }
}

export const changePassword = async (
  passwords: ChangePasswordInput,
  accesstoken: string
) => {
  const response = await http.post<ChangePasswordInput, string>(
    '/user/update-password',
    {
      oldPassword: passwords.oldPassword,
      newPassword: passwords.newPassword,
    },
    {
      headers: {
        accessToken: accesstoken,
      },
    }
  )

  return response.data
}

export const updateTemporaryPassword = async (
  email: string,
  newPassword: string,
  session: string
) => {
  try {
    const response = await http.post<
      UpdatePasswordTemporaryInput,
      AuthResponse
    >(
      '/user/updateTemporaryPassword',
      {
        email,
        newPassword,
      },
      {
        headers: {
          session,
          'x-userId': email,
          'x-email': email,
          'x-context': 'AUT-WEB',
        },
      }
    )
    return response.data
  } catch (error) {
    return null
  }
}

export const refreshToken = async (
  email: string,
  refreshToken: string
): Promise<AuthResponse | null> => {
  try {
    const response = await http.post<RefreshTokenInput, AuthResponse>(
      '/user/refreshToken',
      {
        email,
        refreshToken,
      }
    )
    return response.data
  } catch (error) {
    return null
  }
}
